<script>
  import Component from './Component.svelte'
  export let config
</script>

<div class="container mx-auto px-5 py-24 text-left text-gray-600">
  <h2 class="title-font sm:text-2xl text-1xl mb-4 text-gray-900 text-left">
    Test Drive
  </h2>
</div>

<div class="flex">
  <aside class="px-12">
    <form class="flex flex-col">
      <label class="mb-2">
        <p class="text-left">Preheader:</p>
        <input 
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
          type="text" 
          bind:value={config.preheader}>
      </label>

      <label class="mb-2">
        <p class="text-left">Title:</p>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" bind:value={config.title}>
      </label>

      <label class="mb-2">
        <p class="text-left">Subtitle:</p>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" bind:value={config.subtitle}>
      </label>

      <label class="mb-2">
        <p class="text-left">Body:</p>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" bind:value={config.body}>
      </label>

    </form>
  </aside>
  <main class="flex-1 text-left px-12">
    <Component {config} />
  </main>
</div>

<style>
  main {
    border: 2px dashed gray;
  }
</style>